export default __webpack_public_path__ + "static/media/Rectangle 46.6f81bde8.png";